// extracted by mini-css-extract-plugin
module.exports = {"sticky":"index_sticky__25yNm","stickyTop":"index_stickyTop__2t30l","stickyBottom":"index_stickyBottom__2TkI9"};